<!-- Header and sidenav -->
<app-loader-component></app-loader-component>
<app-nav></app-nav>

<!-- pages -->
<router-outlet (activate)="onActivate($event, outlet)" #outlet></router-outlet>
<!-- Footer -->
<app-footer></app-footer>